module.exports = __webpack_public_path__ + "img/accessory_shoe_05.9a67d1b7.svg";